import { createPlugin, createComponentExtension } from '@backstage/core-plugin-api';
import { catalogIndexRouteRef } from './routes.esm.js';

const orgPlugin = createPlugin({
  id: "org",
  externalRoutes: {
    catalogIndex: catalogIndexRouteRef
  }
});
const EntityGroupProfileCard = orgPlugin.provide(
  createComponentExtension({
    name: "EntityGroupProfileCard",
    component: {
      lazy: () => import('./components/index.esm.js').then((m) => m.GroupProfileCard)
    }
  })
);
const EntityMembersListCard = orgPlugin.provide(
  createComponentExtension({
    name: "EntityMembersListCard",
    component: {
      lazy: () => import('./components/index.esm.js').then((m) => m.MembersListCard)
    }
  })
);
const EntityOwnershipCard = orgPlugin.provide(
  createComponentExtension({
    name: "EntityOwnershipCard",
    component: {
      lazy: () => import('./components/index.esm.js').then((m) => m.OwnershipCard)
    }
  })
);
const EntityUserProfileCard = orgPlugin.provide(
  createComponentExtension({
    name: "EntityUserProfileCard",
    component: {
      lazy: () => import('./components/index.esm.js').then((m) => m.UserProfileCard)
    }
  })
);

export { EntityGroupProfileCard, EntityMembersListCard, EntityOwnershipCard, EntityUserProfileCard, orgPlugin };
//# sourceMappingURL=plugin.esm.js.map
